/**
 * FormHeaderCard — read-only header block for magic-link forms.
 *
 * Mirrors the header table on the canonical paper forms (EPR Form.docx /
 * 360 Review Fom.docx): Employee Name, Position, Department, Review
 * Period, Supervisor/Reviewer, Review Date. Every value is auto-filled
 * from the launch snapshot — participants never type any of it (§L.2
 * progressive disclosure; adaptive form).
 *
 * Rows with no value render as "—" so the participant can tell HR the
 * snapshot is incomplete, rather than silently hiding the field.
 */

import React from 'react';

export interface FormHeaderRow {
  label: string;
  value?: string;
}

const FormHeaderCard: React.FC<{
  title: string;
  rows: FormHeaderRow[];
}> = ({ title, rows }) => (
  <div className="rounded-xl border border-stone-200 bg-white overflow-hidden">
    <div className="px-5 py-3 border-b border-stone-200 bg-stone-50">
      <div className="text-sm font-semibold text-stone-900">{title}</div>
    </div>
    <dl className="px-5 py-3 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-1.5 text-sm">
      {rows.map(r => (
        <div key={r.label} className="flex gap-2 min-w-0">
          <dt className="text-stone-500 flex-shrink-0 w-32">{r.label}</dt>
          <dd className="text-stone-900 font-medium truncate">{r.value || '—'}</dd>
        </div>
      ))}
    </dl>
  </div>
);

export default FormHeaderCard;
